import React, { useEffect, useState } from 'react';
import Button from './Button';

/**
 * "Updated 40 s ago · Refresh" for a page served from the fast cache
 * (23 Oct 2026). `at` is the server's cached_at; Refresh asks the server to
 * rebuild now (?refresh=1).
 */
const ago = (at) => {
  const s = Math.max(0, Math.round((Date.now() - new Date(at).getTime()) / 1000));
  if (s < 10) return 'just now';
  if (s < 60) return `${s} s ago`;
  const m = Math.round(s / 60);
  return m < 60 ? `${m} min ago` : `${Math.round(m / 60)} h ago`;
};

export default function FreshnessNote({ at, onRefresh, busy = false }) {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 15000); return () => clearInterval(t); }, []);
  return (
    <span className="c-fresh">
      {at && <span className="c-fresh-t" title={new Date(at).toLocaleString('en-IN')}>Updated {ago(at)}</span>}
      {onRefresh && <Button variant="quiet" disabled={busy} onClick={onRefresh}>{busy ? 'Refreshing…' : '↻ Refresh'}</Button>}
    </span>
  );
}
